import React from 'react'
import { Provider } from 'react-redux'
import { history, store, persistor } from './redux'
import NavigationRouter from './navigation/NavigationRouter'
import { PersistGate } from 'redux-persist/integration/react'
import { ErrorBoundary } from 'react-error-boundary'
import CriticalErrorFallbackComponent from './components/ErrorFallbacks'
  
import "./icons/font-awesome/font-awesome.min.css";
import "./icons/ionicons/ionicons.min.css";
import "./icons/material-design/material-design.min.css";

const App = () => (
  <ErrorBoundary  fallbackRender={({ error }) => <CriticalErrorFallbackComponent error={error} />}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <NavigationRouter history={history} />
      </PersistGate>
    </Provider>
  </ErrorBoundary>
)

export default App